import { Route, Redirect } from "react-router-dom";

const ProtectedRoute = ({ component: Component, render, isAuthenticated, ...props }) => {
    return (
        <Route
            {...props}
            render={(routeProps) =>
                isAuthenticated ? render ? render(routeProps) : <Component {...routeProps} /> : <Redirect to="/login" />
            }
        />
    );
};

export default ProtectedRoute;
